import React from 'react';
import { Route } from 'react-router-dom';
import SubscriptionsIframe from '.';

export const path = '/subscriptions';

export default [<Route match path={path} component={SubscriptionsIframe} key={path} />];
